let dialog;
let opener;
let previousOverflow;

function createDialog() {
  const element = document.createElement('dialog');
  element.className = 'sq-size-dialog';
  element.setAttribute('aria-labelledby', 'sq-size-dialog-title');
  element.setAttribute('aria-describedby', 'sq-size-dialog-instructions');
  element.innerHTML = `
    <div class="sq-size-dialog__header">
      <h2 id="sq-size-dialog-title" class="sq-size-dialog__title"></h2>
      <button type="button" class="sq-size-dialog__close" autofocus>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="m6 6 12 12M18 6 6 18"></path></svg>
      </button>
    </div>
    <div class="sq-size-dialog__body">
      <p id="sq-size-dialog-instructions" class="sq-size-dialog__instructions"></p>
      <p class="sq-size-dialog__error" role="status" hidden></p>
      <div class="sq-size-dialog__viewport"><img class="sq-size-dialog__image" decoding="async"></div>
      <div class="sq-size-dialog__actions">
        <button type="button" class="sq-size-dialog__zoom" aria-pressed="false"></button>
        <a class="sq-size-dialog__full" target="_blank" rel="noopener"></a>
      </div>
    </div>`;
  element.querySelector('.sq-size-dialog__close').addEventListener('click', () => element.close());
  element.addEventListener('click', (event) => {
    if (event.target !== element) return;
    const rect = element.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) element.close();
  });
  element.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  element.querySelector('.sq-size-dialog__zoom').addEventListener('click', (event) => {
    const viewport = element.querySelector('.sq-size-dialog__viewport');
    const enlarged = viewport.classList.toggle('is-enlarged');
    event.currentTarget.setAttribute('aria-pressed', String(enlarged));
    event.currentTarget.textContent = enlarged ? opener.dataset.reduce : opener.dataset.enlarge;
  });
  document.body.append(element);
  return element;
}

export function openSizeGuide(button) {
  const data = button.dataset;
  if (!data.chart) return;
  if (!dialog) dialog = createDialog();
  if (dialog.open) return;
  opener = button;
  const image = dialog.querySelector('.sq-size-dialog__image');
  const error = dialog.querySelector('.sq-size-dialog__error');
  const viewport = dialog.querySelector('.sq-size-dialog__viewport');
  const zoom = dialog.querySelector('.sq-size-dialog__zoom');
  const full = dialog.querySelector('.sq-size-dialog__full');
  dialog.querySelector('.sq-size-dialog__title').textContent = data.title;
  dialog.querySelector('.sq-size-dialog__instructions').textContent = data.instructions;
  dialog.querySelector('.sq-size-dialog__close').setAttribute('aria-label', data.close);
  error.textContent = data.error;
  error.hidden = true;
  viewport.classList.remove('is-enlarged');
  viewport.scrollLeft = 0;
  zoom.textContent = data.enlarge;
  zoom.setAttribute('aria-pressed', 'false');
  full.textContent = data.full;
  full.href = data.chart;
  full.setAttribute('aria-label', `${data.full} (${data.newTab})`);
  image.alt = `${data.title} — ${button.textContent.trim()}`;
  image.hidden = false;
  image.onload = () => { error.hidden = true; };
  image.onerror = () => { error.hidden = false; image.hidden = true; };
  image.src = data.chart;
  previousOverflow = document.documentElement.style.overflow;
  dialog.showModal();
  document.documentElement.style.overflow = 'hidden';
  dialog.querySelector('.sq-size-dialog__close').focus({ preventScroll: true });
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-sq-size-guide]');
  if (!button) return;
  event.preventDefault();
  openSizeGuide(button);
});
